import { Button, Modal, Select } from 'flowbite-react';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import AssetApi from '../../../Api/AssetApi';
import { Asset } from '../../../Models/Asset';
import { AssetTypeEnum } from '../../../Models/AssetType';
import { AssetStatusEnum } from '../../../Models/AssetStatus';

export default function DriverSelectAsset({
  show,
  setShow,
  assetType,
  setselectedAsset,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  assetType: number;
  setselectedAsset: React.Dispatch<React.SetStateAction<Asset | null>>;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [assetListData, setassetListData] = useState<Asset[]>([]);

  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<Asset>({
    id: 0,
    name: null,
    number: null,
    dateCreated: null,
    statusId: 1,
    typeId: 1,
    vin: null,
    color: null,
    originalMileage: null,
    currentMileage: null,
    currentMileageDate: null,
    year: null,
    make: null,
    model: null,
    purchasePrice: null,

    assetQuantities: [],
    status: null,
    type: null,
  });

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getAssets = useCallback(() => {
    try {
      setIsLoading(true);
      return AssetApi.getAssetList()
        .then((res) => {
          setassetListData(
            res.data.filter(
              (x) =>
                x.statusId === AssetStatusEnum.GreenTagged ||
                x.statusId == AssetStatusEnum.YellowTagged
            )
          );
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
        });
    } catch (error) {
      console.error(error);
      toast.error('Error');
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (show) getAssets();
  }, [show]);

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    const asset = assetListData.find((x) => x.id === +formData.id);
    setselectedAsset(asset!);
    setButtonDisabled(false);
    onCloseModal();
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='lg' onClose={onCloseModal} popup>
        <Modal.Header>
          Select {assetType === AssetTypeEnum.Truck ? 'Truck' : 'Trailer'}
        </Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <form id='selectAssetForm' onSubmit={onSubmit}>
                <div className='text-black'>
                  <Select
                    id='id'
                    name='id'
                    onChange={handleChangeSelect}
                    value={formData.id ?? ''}
                    sizing='md'
                  >
                    <option value={''}>
                      (Select{' '}
                      {assetType === AssetTypeEnum.Truck ? 'Truck' : 'Trailer'})
                    </option>
                    {assetListData
                      .filter((x) => x.typeId === assetType)
                      .sort((a, b) =>
                        (a.type?.name ?? '').localeCompare(b.type?.name ?? '')
                      )
                      .map((obj) => (
                        <option key={obj.id} value={obj.id}>
                          {obj.name}
                          {' - '}
                          {obj.number}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className='flex justify-end pt-2'>
                  <Button
                    disabled={buttonDisabled}
                    type='submit'
                    className='buttonMain'
                    form='selectAssetForm'
                    // onClick={() => onSubmit()}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
